import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import MartProductCard from "./MartProductCard";
import "./MartAllProducts.css";

const MART_API_BASE = "https://api.atrmart.in/martapi";

const MartAllProducts = ({
  cart,
  addToCart,
  removeFromCart,
  wishlist,
  toggleWishlist,
  user,
  onLoginClick
}) => {
  const navigate = useNavigate();

  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [search, setSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [sortType, setSortType] = useState("newest");

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAllData();
  }, []);

  const fetchAllData = async () => {
    try {
      setLoading(true);

      const [productRes, categoryRes] = await Promise.all([
        axios.get(`${MART_API_BASE}/products`),
        axios.get(`${MART_API_BASE}/categories`)
      ]);

      const productData =
        productRes.data?.data || productRes.data || [];

      const categoryData =
        categoryRes.data?.data || categoryRes.data || [];

      setProducts(productData);
      setFilteredProducts(productData);
      setCategories(categoryData);

    } catch (error) {
      console.error("Failed loading products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let updated = [...products];

    // Search
    if (search) {
      updated = updated.filter((item) =>
        (item.name || "")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    // Category
    if (selectedCategory !== "All") {
      updated = updated.filter(
        (item) =>
          String(item.category_id) ===
          String(selectedCategory)
      );
    }

    // Sort
    switch (sortType) {
      case "low":
        updated.sort(
          (a, b) =>
            Number(a.price || 0) -
            Number(b.price || 0)
        );
        break;

      case "high":
        updated.sort(
          (a, b) =>
            Number(b.price || 0) -
            Number(a.price || 0)
        );
        break;

      default:
        updated.sort(
          (a, b) =>
            Number(b.id || 0) -
            Number(a.id || 0)
        );
    }

    setFilteredProducts(updated);
  }, [search, selectedCategory, sortType, products]);

  return (
    <div className="mart-all-wrapper">

      {/* HEADER */}

      <div className="mart-all-header">
        <h1>All Products</h1>

        <button
          className="mart-back-btn"
          onClick={() => navigate("/mart")}
        >
          ← Back Home
        </button>
      </div>

      {/* TOP FILTERS */}

      <div className="mart-top-controls">

        <input
          type="text"
          placeholder="Search products..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select
          value={sortType}
          onChange={(e) => setSortType(e.target.value)}
        >
          <option value="newest">Newest</option>
          <option value="low">Price Low → High</option>
          <option value="high">Price High → Low</option>
        </select>

      </div>

      <div className="mart-content">

        {/* SIDEBAR */}

        <div className="mart-sidebar">

          <h3>Categories</h3>

          <button
            className={
              selectedCategory === "All"
                ? "active-category"
                : ""
            }
            onClick={() => setSelectedCategory("All")}
          >
            All Products
          </button>

          {categories.map((cat) => (
            <button
              key={cat.id}
              className={
                String(selectedCategory) ===
                String(cat.id)
                  ? "active-category"
                  : ""
              }
              onClick={() =>
                setSelectedCategory(cat.id)
              }
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* PRODUCTS */}

        <div className="mart-products-section">

          {loading ? (
            <div className="loader">
              Loading Products...
            </div>
          ) : (
            <>
              <div className="results-count">
                {filteredProducts.length} Products Found
              </div>

              <div className="products-grid">

                {filteredProducts.map((item) => (
                  <MartProductCard
                    key={item.id}
                    item={item}
                    navigate={navigate}
                    addToCart={addToCart}
                    removeFromCart={removeFromCart}
                    cart={cart}
                    user={user}
                    onLoginClick={onLoginClick}
                    wishlist={wishlist}
                    toggleWishlist={toggleWishlist}
                  />
                ))}

              </div>
            </>
          )}

        </div>

      </div>

    </div>
  );
};

export default MartAllProducts;